export default [
  {
    name: "base",
    data: {},
    items: [
      {
        name: "collision",
        source: "/assets/models/scene.glb",
        type: "model",
      },
      {
        name: "door",
        source: "/assets/models/door.glb",
        type: "model",
      },
      {
        name: "vaseAnimation",
        source: "/assets/models/vase.glb",
        type: "model",
      },
      {
        name: "vase",
        source: "/assets/models/vase_idle.glb",
        type: "model",
      },
      {
        name: "baked",
        source: "/assets/baked/baked.ktx2",
        type: "texture",
      },
      {
        name: "starduster",
        source: "/assets/paintings/starduster.ktx2",
        type: "texture",
      },
      {
        name: "ghostlyFootsteps",
        source: "/assets/paintings/ghostly-footsteps.ktx2",
        type: "texture",
      },
      {
        name: "apocalypseNow",
        source: "/assets/paintings/apocalypse-now.ktx2",
        type: "texture",
      },
      {
        name: "tfg",
        source: "/assets/paintings/tfg.ktx2",
        type: "texture",
      },
      {
        name: "saveTheCrew",
        source: "/assets/paintings/save-the-crew.ktx2",
        type: "texture",
      },
      {
        name: "breakIn",
        source: "/assets/paintings/break-in.ktx2",
        type: "texture",
      },
      {
        name: "cobayaUnchained",
        source: "/assets/paintings/cobayaunchained.ktx2",
        type: "texture",
      },
      {
        name: "qomp",
        source: "/assets/paintings/qomp.ktx2",
        type: "texture",
      },
      {
        name: "portfolio",
        source: "/assets/paintings/portfolio.ktx2",
        type: "texture",
      },
      {
        name: "stardusterNote",
        source: "/assets/notes/starduster-note.ktx2",
        type: "texture",
      },
      {
        name: "qompNote",
        source: "/assets/notes/qomp-note.ktx2",
        type: "texture",
      },
      {
        name: "ghostlyFootstepsNote",
        source: "/assets/notes/ghostlyFootsteps-note.ktx2",
        type: "texture",
      },
      {
        name: "cobayaUnchainedNote",
        source: "/assets/notes/cobayaUnchained-note.ktx2",
        type: "texture",
      },
      {
        name: "breakInNote",
        source: "/assets/notes/breakIn-note.ktx2",
        type: "texture",
      },
      {
        name: "portfolioNote",
        source: "/assets/notes/portfolio-note.ktx2",
        type: "texture",
      },
      {
        name: "nextButton",
        source: "/assets/descriptionButtons/next-button.ktx2",
        type: "texture",
      },
      {
        name: "prevButton",
        source: "/assets/descriptionButtons/prev-button.ktx2",
        type: "texture",
      },
      {
        name: "liveDemo",
        source: "/assets/descriptionButtons/live-demo.ktx2",
        type: "texture",
      },
      {
        name: "sourceCode",
        source: "/assets/descriptionButtons/source-code.ktx2",
        type: "texture",
      },
      {
        name: "joanArtGallery",
        source: "/assets/paintings/joan-art-gallery.ktx2",
        type: "texture",
      },
      {
        name: "joanArcadeMachine",
        source: "/assets/paintings/joan-arcade-machine.ktx2",
        type: "texture",
      },
      {
        name: "joanOS",
        source: "/assets/paintings/joan-os.ktx2",
        type: "texture",
      },
      {
        name: "vaseTexture",
        source: "/assets/vase/vaseTexture.ktx2",
        type: "texture",
      },
      {
        name: "portfolioDescription",
        source: "/assets/descriptions/portfolio-description.png",
        type: "texture",
      },
      {
        name: "stardusterDescription",
        source: "/assets/descriptions/starduster-description.png",
        type: "texture",
      },

      {
        name: "cobayaunchainedDescription",
        source: "/assets/descriptions/cobayaunchained-description.png",
        type: "texture",
      },

      {
        name: "ghostlyFootstepsDescription",
        source: "/assets/descriptions/ghostly-footsteps-description.png",
        type: "texture",
      },
      {
        name: "breakInDescription",
        source: "/assets/descriptions/break-in-description.png",
        type: "texture",
      },
      {
        name: "qompDescription",
        source: "/assets/descriptions/qomp-description.png",
        type: "texture",
      },
      {
        name: "trophyGold",
        source: "/assets/trophyLogos/trophy-gold.png",
        type: "texture",
      },
      {
        name: "trophySilver",
        source: "/assets/trophyLogos/trophy-silver.png",
        type: "texture",
      },
      {
        name: "trophyBronze",
        source: "/assets/trophyLogos/trophy-bronze.png",
        type: "texture",
      },
      {
        name: "trophyPlatinum",
        source: "/assets/trophyLogos/trophy-platinum.png",
        type: "texture",
      },

      {
        name: "joanArtGalleryDescription",
        source: "/assets/descriptions/joan-art-gallery-description.png",
        type: "texture",
      },

      {
        name: "joanArcadeMachineDescription",
        source: "/assets/descriptions/joan-arcade-machine-description.png",
        type: "texture",
      },

      {
        name: "joanOSDescription",
        source: "/assets/descriptions/joan-os-description.png",
        type: "texture",
      },
      {
        name: "doNotTouchTrophy",
        source: "/assets/trophies/do-not-touch-trophy.png",
        type: "texture",
      },
      {
        name: "doNotTouch",
        source: "/assets/notes/do-not-touch.png",
        type: "texture",
      },

      {
        name: "doorTrophy",
        source: "/assets/trophies/door-trophy.png",
        type: "texture",
      },
      {
        name: "sourceCodeTrophy",
        source: "/assets/trophies/source-code-trophy.png",
        type: "texture",
      },
      {
        name: "liveDemoTrophy",
        source: "/assets/trophies/live-demo-trophy.png",
        type: "texture",
      },
      {
        name: "nextTrophy",
        source: "/assets/trophies/next-trophy.png",
        type: "texture",
      },
      {
        name: "prevTrophy",
        source: "/assets/trophies/prev-trophy.png",
        type: "texture",
      },
      {
        name: "canvasTrophy",
        source: "/assets/trophies/canvas-trophy.png",
        type: "texture",
      },
      {
        name: "platinumTrophy",
        source: "/assets/trophies/platinum-trophy.png",
        type: "texture",
      },
    ],
  },
];
